import { getUserId } from 'src/utils/auth';
import { Id } from 'src/utils/types';
import { request } from '.';

export type CreatePsychologistActionPayload = {
  action_id: string;
  data: string;
  id_empresa: string;
  titulo: string;
  numero_participantes: string;
};

export type PsychologistAction = {
  id: number;
  acao: string;
  titulo: string | null;
  data: string;
  empresa: string;
  remuneracao: number;
  numero_participantes: number | null;
  rejeitada: boolean;
}

export type Action = {
  id: number;
  acao: string;
  remuneracao: number;
}

export async function createPsychologistAction(data: CreatePsychologistActionPayload) {
  const id = getUserId();
  return await request.post<null>(`/psicologos/${id}/actions`, data);
}

export async function getPsychologistActions(startDate: string, endDate: string): Promise<PsychologistAction[]> {
  const id = getUserId();
  const response = await request.get<PsychologistAction[]>(`/psicologos/${id}/actions`, {
    params: {
      start_date: startDate,
      end_date: endDate,
    }
  });
  
  if (!response.data) {
    return [];
  }
  
  return response.data;
}

export async function getActions(): Promise<Action[]> {
  const response = await request.get<PsychologistAction[]>("/actions")

  if (!response.data) {
    return [];
  }

  return response.data;
}

export type ActionModerationStatus = 'pending' | 'accepted' | 'rejected';

export type ModerationAction = {
  id: number;
  data: string;
  titulo: string | null;
  acao: string | null;
  id_empresa: number | null;
  empresa: string | null;
  id_psicologo: number | null;
  psicologo: string | null;
  numero_participantes: number | null;
  status: ActionModerationStatus;
  rejection_reason: string | null;
};

export type ModerationFilters = {
  status?: ActionModerationStatus | '';
  company_id?: Id;
};

export async function getActionsModeration(
  filters: ModerationFilters = {}
): Promise<ModerationAction[]> {
  const params: Record<string, string> = {};
  if (filters.status) params.status = filters.status;
  if (filters.company_id) params.company_id = String(filters.company_id);

  const response = await request.get<ModerationAction[]>("/actions/moderation", { params });
  return response.data ?? [];
}

export async function acceptAction(id: number) {
  return await request.patch<{ id: number; status: string }>(`/actions/moderation/${id}/accept`);
}

export async function rejectAction(id: number, reason: string) {
  return await request.patch<{ id: number; status: string }>(
    `/actions/moderation/${id}/reject`,
    { reason }
  );
}